module.exports = __webpack_public_path__ + "static/banner-image-a8b41d0561ff8c6ea64fb387b93f123a.png";